const
  NAME               = 'newslettersStickyPopups',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME]
;

class NewslettersStrickyPopups {
  constructor(element$) {
    this._element$ = element$;

    //Controla que salte el popup de aviso en el formulario de newsletter si haces un cambio y navegas sin guardar
    var change_checkbox = false,
        url_destino;

    $("#form-newsletters, #form-newsletters-anonimo").find(".form-input, .css-checkbox--s").one('change', function() {
        change_checkbox = true;
        //Si se hace algun cambio, se muestra el sticky de guardar
        $('.savesticky').addClass('show');
    });

    $("#form-newsletters .savesticky .ap-btn").one('click', function() {
        change_checkbox = false;
        //Solo se oculta el sticky en Newsletter no anonima
        $('.savesticky').removeClass('show');
    });

    $(".js-guardar").one('click', function() {
        change_checkbox = false;
        $('.savesticky').removeClass('show');
        $("#form-newsletters").submit();
    });

    $(".js-salirsinguardar").one('click', function() {
        window.location.href = url_destino;
    });

    //En la pagina de newsletter, al hacer click en cualquier link, si el usuario ha hecho algun cambio, salta modal de aviso
    $('a').on('click',function(e){
        if( $("#form-newsletters").length === 1 && change_checkbox === true  ) {
            url_destino = $(this).attr('href');
            e.preventDefault();
            $("#ap-modal-bg").show();
            $("#modal-newsletter-aviso-guardar").show();
            return false;
        }
    });

    //Plegar modulos
    $('.js-seccionplegable').find('.js-plegador').on('click', function(){
        $(this).parents('.js-seccionplegable').toggleClass('cerrado').find('.js-plegable').slideToggle();
    });

    // Abrir una modal desde UI:
    // Boton debe tener la clase js-abrirmodal y atributo data-opemodal con el valor del id de la modal que se quiera abrir
    $('.js-abrirmodal').each(function(){
        $(this).on('click', function(e){

            var puntero = $(this).data('openmodal');
            var selectorModal = "#" + puntero ;

            e.preventDefault();
            e.stopPropagation();
            $('#ap-modal-bg').show();// opacidad
            $(selectorModal).show();

        });
    });

    //Cerrar modal
    $('.js-cerrarmodal, .ap-modal-ico-cerrar').on('click', function(e){
        e.preventDefault();
        $(this).parents('.modalbox').hide();
        $('#ap-modal-bg').hide();// opacidad
    });

    //Select-customizados
    //Coge el texto del option selected y lo mete en el span 'falso'
    $('.js-selectcustom').each(function(){
        var textValor = $(this).find('[selected=selected]').text();
        $(this).find('.js-selectcustom-optionfalse').text(textValor);
    });

    //Al seleccionar una opcion del combo
    $('.js-selectcustom').find('select').each(function(){
        $(this).on('change', function(){
            $(this).siblings('.js-selectcustom-optionfalse').text(  $(this).find('option:selected').text() );
        });
    });

    //Icono Whatsapp en ClubDetalle
    if( navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i) ){
       $('.ap-detalle-compartir-item.wa').removeClass('novisible');
    }

  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface() {
    return this.each(function() {
      new NewslettersStrickyPopups($(this));
    });
  }
}

$.fn[NAME]             = NewslettersStrickyPopups._jQueryInterface;
$.fn[NAME].Constructor = NewslettersStrickyPopups;
$.fn[NAME].noConflict  = function noConflict() {
$.fn[NAME]             = JQUERY_NO_CONFLICT;
return NewslettersStrickyPopups._jQueryInterface;
};

export default NewslettersStrickyPopups;



// WEBPACK FOOTER //
// ./src/plugins/newsletters-sticky-popups.js